<template>
  <el-dialog title="新增租户" :visible.sync="visible" width="40%" >
    <el-form :model="data" :rules="rules" ref="addForm" label-width="90px">
      <el-card shadow="never" class="el-card-simple">
        <div slot="header">
          <span>公司信息</span>
        </div>
        <el-form-item label="公司简称:" prop="name">
          <el-input v-model="data.name" :maxlength="32" placeholder="请输入公司简称" clearable/>
        </el-form-item>
        <el-form-item label="公司全称:" prop="fullName">
          <el-input v-model="data.fullName" :maxlength="128" placeholder="请输入公司全称" clearable/>
        </el-form-item>
      </el-card>
      <el-card shadow="never" class="el-card-simple">
        <div slot="header">
          <span>用户信息</span>
        </div>
        <el-form-item label="手机号:" prop="linkTel">
          <el-input v-model="data.linkTel" placeholder="请输入手机号" clearable @input="phoneChange"/>
        </el-form-item>
        <el-form-item label="用户昵称:" prop="linkNickName">
          <el-input v-model="data.linkNickName" :maxlength="30" placeholder="请输入用户昵称" clearable/>
        </el-form-item>
      </el-card>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UserSelect from "@/views/crm/components/userSelect";
import CompanyInput from "@/views/crm/components/companyInput";
import { mapState } from 'vuex'
import {saveTenant} from "@/api/system/tenant";
import {isPhone} from "@/utils/validate";
import {checkPhoneOnAdd} from "@/api/system/user";

export default {
  name: "AddTenantDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      sourceOptions: [],
      addUserExist: false,
      rules: {
        name: [
          {required: true, message: '请输入公司简称', trigger: 'change'},
          {max: 32, message: '长度过长', trigger: 'change'}
        ],
        fullName: [
          {required: true, message: '请输入公司名称', trigger: 'change'},
          {max: 128, message: '长度过长', trigger: 'change'}
        ],
        linkNickName: [
          {required: true, message: '请输入用户昵称', trigger: 'change'},
          {max: 30, message: '长度过长', trigger: 'change'}
        ],
        linkTel: [
          {required: true, validator: this.checkMobile, trigger: "change" }
        ]
      },
      data: {
        name: null,
        fullName: null,
        linkNickName: null,
        linkTel: null
      }
    };
  },
  created() {
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect,
    CompanyInput
  },
  watch: {
    visible (val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open () {
      this.visible = true
    },
    checkMobile (rule, value, callback) {
      //必填
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (isPhone(value)) {
        callback()
      } else {
        callback(new Error('格式不正确'))
      }
    },
    phoneChange(phonenumber) {
      // 新增用户的时候需要校验
      if (isPhone(phonenumber)) {
        checkPhoneOnAdd(phonenumber).then(response => {
            if (response.data && response.data.userId) {
              this.addUserExist = true;
              this.data.linkNickName = response.data.nickName;
            } else {
              this.addUserExist = false;
            }
          }
        ).catch(error => {
          this.addUserExist = false;
        })
      }
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          saveTenant(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("租户新增成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
